exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-2b6e9afc],.aside[data-v-2b6e9afc]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.form[data-v-2b6e9afc]{width:100%}.form__element[data-v-2b6e9afc]{margin:var(--spacer-base) 0}.form__checkbox[data-v-2b6e9afc]{margin:var(--spacer-xl) 0 var(--spacer-2xl) 0}.form__submit[data-v-2b6e9afc]{margin:var(--spacer-xl) 0 0 0}.action-button[data-v-2b6e9afc]{margin:var(--spacer-xl) 0}.aside[data-v-2b6e9afc]{margin:0 0 var(--spacer-xl) 0}.aside__heading[data-v-2b6e9afc]{--heading-title-color: var(--c-primary);margin:0 0 var(--spacer-sm) 0}\n", ""]);

// exports
